import { Heading1, px } from '@liasincontrol/ui-basics';
import styled from 'styled-components';

const Title = styled(Heading1)`
    margin: 0 0 ${px(4)} 0;
`;

export { Title };